import { useCallback, useContext, useEffect } from 'react';

import { CommunicationContext } from 'utility/Provide/Context/PageContext';

import { GalleryActionContext } from '../__context';
import { OpenGalleryProps } from '../types';

const useLegacyListener = () => {
    const context = useContext(CommunicationContext);
    const { openHotelGallery } = useContext(GalleryActionContext);

    const openGallery_ = useCallback(
        (data: OpenGalleryProps) => {
            !!data.hotelId &&
                openHotelGallery({
                    hotelId: data.hotelId,
                    callback: data.callback,
                    closeAfterCallback: data.closeAfterCallback,
                    step4Url: data.step4Url,
                    shareLeafletUrl: data.shareLeafletUrl,
                });
        },
        [openHotelGallery]
    );

    useEffect(() => {
        context.react.bind('open_gallery', openGallery_);
        return () => {
            context.react.unbind('open_gallery');
        };
    }, [context.react, openGallery_]);
};

export default useLegacyListener;
